import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import {useHistory} from "react-router-dom";
import {sideMenuContext} from "../../../router/IndexRouter";
import {Arguments} from "../common/Arguments";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import SearchBox from "../common/SearchBoxComponent";


export default function PolicyRegulations() {
    const {setCurrentItem} = useContext(sideMenuContext)
    const history = useHistory()
    const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/policy/api!policyRegulation.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const handleTitleClick = (item) => {
        history.push(`/system/policy-regulations/${item.policyId}`);
        setCurrentItem(item);
    };

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '标题',
            dataIndex: 'title',
            render: (title, item) => (
                <Button type="link" onClick={() => {
                    handleTitleClick(item)
                }}><b>{title}</b></Button>
            )
        },
        {
            title: '发布日期',
            dataIndex: 'publishDate'
        }
    ];

    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))

    return (
        <>
            <SearchBox placeholder="输入标题关键字"/>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}





